export const mobileNav = () => {

	const mobileNavOpenTriggers = document.querySelectorAll('.js-open-nav');
    
 	mobileNavOpenTriggers.forEach(mobileNavOpenTrigger => {

        mobileNavOpenTrigger.addEventListener('click', function() {
            document.querySelector('.popup-nav').classList.add('active');
        });
    });

    const mobileNavCloseTriggers = document.querySelectorAll('.js-close-nav');
    
    mobileNavCloseTriggers.forEach(mobileNavCloseTrigger => {
        mobileNavCloseTrigger.addEventListener('click', function() {
            document.querySelector('.popup-nav').classList.remove('active');
        });
    });
}